import { render, staticRenderFns } from "./RightArea.vue?vue&type=template&id=69df6076&"
import script from "./RightArea.vue?vue&type=script&lang=ts&"
export * from "./RightArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports